import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ConversationStatus, CopilotConversation } from '../models/copilot.interface';

@Component({
  selector: 'sbnb-chat-list-item',
  templateUrl: './chat-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatListItemComponent {
  @Input() conversation!: CopilotConversation;
  @Input() currentConversationUuid?: string;
  @Output() conversationClicked = new EventEmitter<CopilotConversation>();
  @Output() deleteClicked = new EventEmitter<{ event: Event; conversation: CopilotConversation }>();

  ConversationStatus = ConversationStatus;

  get showLoadingSpinner(): boolean {
    return this.conversation.status === ConversationStatus.InProgress;
  }

  onConversationClick(): void {
    this.conversationClicked.emit(this.conversation);
  }

  onDeleteClick(event: Event): void {
    this.deleteClicked.emit({ event, conversation: this.conversation });
  }
}
